import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VEHICLE_WIZARD_SAMPLE } from "../consts";
import { getVehiclePlate } from "../helpers";
import { VehicleWizardSceneProps } from "../types";
import CheckIcon from "./CheckIcon";

/** Korak "Dokumenti": popis dokumenata sa statusom, PDF datoteka i dostupnost dokumenata. */
const DocumentsScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  const documents =
    vehicleInfo.documentTypesStatus.length > 0
      ? vehicleInfo.documentTypesStatus
      : VEHICLE_WIZARD_SAMPLE.documents.map((name, index) => ({ name, hasDocuments: index < 2 }));

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Dokumenti vozila</div>
          <div className="mt-3 space-y-2">
            {documents.slice(0, 4).map((document) => (
              <div key={document.name} className="flex items-center gap-2 rounded-md bg-slate-50 px-2 py-2">
                {document.hasDocuments ? (
                  <CheckIcon />
                ) : (
                  <span className="w-5 h-5 rounded-full border-2 border-dashed border-slate-300 flex-shrink-0" />
                )}
                <span className="flex-1 text-[0.7rem] font-medium text-slate-700 truncate">{document.name}</span>
                <span
                  className={
                    document.hasDocuments
                      ? "text-[0.6rem] font-semibold text-emerald-600"
                      : "text-[0.6rem] font-semibold text-slate-400"
                  }
                >
                  {document.hasDocuments ? "Učitano" : "Nedostaje"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-10 h-12 rounded-md bg-rose-50 text-[0.6rem] font-bold text-rose-500 flex-shrink-0">
              PDF
            </span>
            <div className="min-w-0">
              <div className="text-xs font-bold text-slate-800 truncate">prometna-dozvola.pdf</div>
              <div className="text-[0.65rem] text-slate-400">248 KB</div>
            </div>
          </div>
          <div className="mt-4 space-y-1.5">
            <div className="h-1.5 w-full rounded-full bg-slate-100" />
            <div className="h-1.5 w-4/5 rounded-full bg-slate-100" />
            <div className="h-1.5 w-3/5 rounded-full bg-slate-100" />
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Dokumenti su uvijek pri ruci"
          subtitle={`${getVehiclePlate(vehicleInfo)} · na detaljima vozila`}
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(DocumentsScene);
